import React from "react";
import DesktopHeader from "./desktop";
import MobileHeader from "./mobile";
import AnnouncementBanner from "./announcement-banner";

const Header = ({ data }) => (
    <>
        {data?.announcementBanner?.show && <AnnouncementBanner data={data} /> }
        <DesktopHeader data={data} />
        <MobileHeader data={data} />
    </>
);

export default Header;
